import moment from "moment";
import Toast from 'light-toast';
import Plot from 'react-plotly.js';
import React, { useState, useMemo } from 'react';
import { GOOGLE_MAP_API_KEY } from 'assets/constants/Constants';
import { useHistory  } from  "react-router-dom";
import { withScriptjs, withGoogleMap, GoogleMap, Marker, OverlayView} from 'react-google-maps';

export const onSortColumn = (dataArray, column, orderFlag) => {
    let sortedData = [];
    if (orderFlag === "asc") {
        sortedData = dataArray.sort((a, b) => {
            if (a[column] < b[column]) return -1;
            if (a[column] > b[column]) return 1;
            if (a[column] === b[column]) return 1;
            return 1;
        });
    } else {
        sortedData = dataArray.sort((a, b) => {
            if (a[column] > b[column]) return -1;
            if (a[column] < b[column]) return 1;
            if (a[column] === b[column]) return 1;
            return 1;
        });
    }
    return sortedData;
}

export const defaultFormatDate = (item) => {
    let formatedDate = null;
    formatedDate = moment(item).format("DD-MM-YY"); 
    return formatedDate;
}
export const defaultFormatDateTime = (item) => {
    let formatedDate = null;
    formatedDate = moment(item).format("DD/MM/YY hh:mm A"); 
    return formatedDate;
}

export const defaultFormatDateTimeWithSeconds = (item) => {
    let formatedDate = null;
    formatedDate = moment(item).format("DD/MM/YY hh:mm:ss A"); 
    return formatedDate;
}

export const epochToIndianTime = (epochTime) => {
    if (!epochTime) return null;
    const indianTime = moment(epochTime).utcOffset('+05:30');
    return indianTime.format("DD/MM/YY hh:mm:ss A");
};

export const showLoading = (message = "Please wait...") => {
    Toast.loading(message, () => {});
}

export const hideLoading = () => {
    Toast.hide();
}

export const validateIsoDateFormat = (item) => {
    const IsoPattern = /^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{1,3})?(Z|[+-]\d{2}:\d{2}))$/;
    return IsoPattern.test(item);
}

export const totalizerUnit = (item) => { 
  console.log("item",item)
  if (item === null) {
    return null; 
  }
  const unitMap = {
    "0": "m³",
    "1": "L",
    "2": "GAL",
    "3": "ft3",
    "4": "ft3"
  };

  return unitMap[item.totalizer_unit] || null;
};

export const  setTotalizerUnit151 = (forwardTotalizer, totalizerUnit) =>{
  return  forwardTotalizer + " "+ (totalizerUnit === 0 ? "m³" : totalizerUnit === 1 ? "m³" : totalizerUnit === 2 ? "m³" : totalizerUnit === 3 ? "m³": totalizerUnit === 4 ? "lit" : totalizerUnit === 5 ? "lit" : totalizerUnit === 6 ? "lit" :  totalizerUnit === 7 ? "lit"  : " ")
}

export const setFlowUnit151 = (flowRate, flowRateUnit) =>{
  return  flowRate + " "+ (flowRateUnit === 0 ? "L/hr" : flowRateUnit === 1 ? "L/min" : flowRateUnit === 2 ? "L/sec" : flowRateUnit === 3 ? "m³/hr": flowRateUnit === 4 ? "m³/min" : flowRateUnit === 5 ? "m³/sec" : "")
}

export const setTotalizerUnit153 = (forwardTotalizer, totalizerUnit) =>{
  return  forwardTotalizer + " "+ (totalizerUnit === 0 ? "m³" : totalizerUnit === 1 ? "lit" : totalizerUnit === 2 ? "GAL" : totalizerUnit === 3 ? "ft3": "")
}

export const setFlowUnit153 = (flowRate, flowRateUnit) =>{
  return  flowRate + " "+ (flowRateUnit === 0 ? "m³/hr" : flowRateUnit === 1 ? "L/hr" : flowRateUnit === 2 ? "GPM" : flowRateUnit === 3 ? "LPS": "")
} 

export const validationFor151 = (totalizerUnit) =>{
  return  totalizerUnit === 0 ? "m³" : totalizerUnit === 1 ? "m³" : totalizerUnit === 2 ? "m³" : totalizerUnit === 3 ? "m³": totalizerUnit === 4 ? "lit" : totalizerUnit === 5 ? "lit" : totalizerUnit === 6 ? "lit" :  totalizerUnit === 7 ? "lit"  : " "
} 

export const validationFor153 = (totalizerUnit) =>{
  return  totalizerUnit === 0 ? "m³" : totalizerUnit === 1 ? "lit" : totalizerUnit === 2 ? "GAL" : totalizerUnit === 3 ? "ft3": ""
} 

export const setPressureUnit171 = (pressureValue, pressureUnit) => {
  if (!pressureValue) {
    pressureValue = "0.00";
  }

  return pressureValue + " " + 
    (pressureUnit === 1 ? "KPa" :
     pressureUnit === 2 ? "x10KPa" :
     pressureUnit === 3 ? "x100KPa" :
     pressureUnit === 4 ? "MPa" :
     pressureUnit === 5 ? "x10MPa" :
     pressureUnit === 6 ? "x100MPa" :
     pressureUnit === 7 ? "Bar" :
     pressureUnit === 8 ? "Kg/cm²" :
     pressureUnit === 9 ? "MWC" :
     pressureUnit === 10 ? "MMWC" :
     "");
};

export const setRadarUnit138 = (radarValue, radarUnit) => {

  if (!radarValue) {
    radarValue = "0.00";
  }

  const unit =
   ( radarUnit === "0" || radarUnit === 0 ) ? "meter" :
   ( radarUnit === "1" || radarUnit === 1 ) ? "cm" :
   ( radarUnit === "2" || radarUnit === 2 ) ? "mm" :
    "";

  return `${radarValue} ${unit}`;
};




const allAlarms153 = [
  "INVALID CAPTURE",
  "Valve_on_off_status",
  "Reserved3 Alarm",
  "Pipe Broken Alarm",
  "Reverse Flow Alarm", 
  "Empty Pipe Alarm",
  "Leak detected Alarm",
  "Low Battery Alarm",
  "LOG_MEMORY_FULL",
  "Data Logger comm. Failed",
  "Data Loss Error",
  "Config Para Update Failed",
  "IP Comm. Fail Error",
  "RWM configuration Mode",
  "BUP Retry Enable / (Commissioned bit)",
  "RWM AM /AMR Mode"
];

const SKIP_ALARMS_153 = [
    "INVALID CAPTURE",
    "Valve_on_off_status"
];

const bpt171Alarms = [
  "Coil Alarm",
  "Reserved",
  "Reserved",
  "Reserved",
  "Reserved",
  "Reserved",
  "Pressure Sensor Open",
  "Pressure Sensor Short",
  "Pressure Over Range",
  "Pressure Under Range",
  "High Pressure",
  "Low Pressure",
  "Reserved"
];

const isMeterON = (no) => {
    return ((no >> 1) & 0x1) === 1;
}

export const getAlarmType153RWM = (decAlarmFlag) => {
    let alarmFlagArray = [];

    for (let index = 0; index < allAlarms153.length; index++) {
        if (isBitSet(decAlarmFlag, index)) {
            const alarmName = allAlarms153[index];

            if (!SKIP_ALARMS_153.includes(alarmName)) {
                alarmFlagArray.push(alarmName);
            }
        }
    }
     return  alarmFlagArray.length === 0 ? "No Alarms" : alarmFlagArray.join(", ");;
};

const allAlarms151MFMP = [
    "Upper Limit Alarm",
    "Lower Limit Alarm",
    "Reverse Flow Alarm",
    "Pipeline Emptly Alarm",
    "System Alarm (Coil Open )",
    "Reserved",
]

export const getAlarmType151MFMP = (decAlarmFlag) => {
  let alarmFlagArray = [];
  console.log("allAlarms151MFMP",decAlarmFlag)
  for (let index = 0; index < allAlarms151MFMP.length; index++) {
      if (isBitSet(decAlarmFlag, index)) {
          alarmFlagArray.push(allAlarms151MFMP[index]);
      }
  }
  return  alarmFlagArray.length === 0 ? "No Alarms" : alarmFlagArray.join(", ");;
 
}

const radar138Alarms = [
  "Reserved",                     
  "GPRS Cycle Fail",               
  "GPRS No Range",               
  "Reserved",                      
  "EEPROM Fail B95",              
  "Data Log Zero",                 
  "Checksum Error",               
  "UART0 Sensor Response Timeout", 
  "Brownout Occurred",            
  "High Level Alarm",              
  "Low Level Alarm",               
  "Low Battery",                   
  "Reserved",                      // BITC
  "Reserved",                      // BITD
  "Reserved",                      // BITE
  "Reserved"                       // BITF
];

const alarmStatus153UIF = [
  "No received signal",
  "Low received signal",
  "Poor received signal",
  "Pipe empty",
  "Hardware failure",
  "Receive circuit gain in adjusting",
  "Frequency at the frequency overflow",
  "Current at 4-20mA overflow",
  "RAM check sum error",
  "Main clock or timer clock error",
  "Parameter check sum error",
  "ROM check sum error",
  "Temperature circuit error",
  "Reserved",
  "Internal timer overflow",
  "Analog input overflow"
];

export const getAlarmType138Radar = (decAlarmFlag) => {
  let alarmFlagArray = [];
  for (let index = 0; index < radar138Alarms.length; index++) {
      if (isBitSet(decAlarmFlag, index)) {
          alarmFlagArray.push(radar138Alarms[index]);
      }
  }
  return  alarmFlagArray.length === 0 ? "No Alarms" : alarmFlagArray.join(", ");;
 
}

export const getAlarmType153UIF = (decAlarmFlag) => {
  let alarmFlagArray = [];
  for (let index = 0; index < alarmStatus153UIF.length; index++) {
      if (isBitSet(decAlarmFlag, index)) {
          alarmFlagArray.push(alarmStatus153UIF[index]);
      }
  }
  return  alarmFlagArray.length === 0 ? "No Alarms" : alarmFlagArray.join(", ");;
 
}


export const setTotalizerUnit151MFMP = (forwardTotalizer, totalizerUnit) => {
    console.log("forwardTotalizer", forwardTotalizer);
    console.log("totalizerUnit", totalizerUnit);
    
    // Convert the value based on the unit
    let convertedValue;
    let unit;
    
    switch(totalizerUnit) {
        case 0: // m³
            convertedValue = forwardTotalizer;
            unit = "m³";
            break;
        case 1: // m³
            convertedValue = forwardTotalizer;
            unit = "m³";
            break;
        case 2: // 0.1 m³
            convertedValue = forwardTotalizer ;
            unit = "m³";
            break;
        case 3: // m³
            convertedValue = forwardTotalizer ;
            unit = "m³";
            break;
        case 4: //m³
            convertedValue = forwardTotalizer ;
            unit = "m³";
            break;
        case 5: // lit
            convertedValue = forwardTotalizer;
            unit = "m³";
            break;
        case 6: // lit
            convertedValue = forwardTotalizer ;
            unit = "L";
            break;
        case 7: // lit
            convertedValue = forwardTotalizer  ;
            unit = "L";
            break;
        default:
            convertedValue = forwardTotalizer;
            unit = " ";
    }
    
    return convertedValue + " " + unit;
}


export const setFlowUnit151MFMP = (flowRate, flowRateUnit) =>{
     return  flowRate + " "+ (flowRateUnit === 1 ? "L/hr" : flowRateUnit === 2 ? "L/min" : flowRateUnit === 3 ? "L/sec" : flowRateUnit === 4 ? "m³/hr": flowRateUnit === 5 ? "m³/min" : flowRateUnit === 6 ? "m³/sec" : "")
}

export const setTotalizerUnit153UCW = (forwardTotalizer) => {
    return forwardTotalizer + " " + "m³" ;
}

export const setFlowUnit153UCW = (flowRate) => {
     return  flowRate +" "+ "m³/hr"
}

export const getAlarmType171BPT = (decAlarmFlag) => {
  let alarmFlagArray = [];
  for (let index = 0; index < bpt171Alarms.length; index++) {
      if (isBitSet(decAlarmFlag, index)) {
          alarmFlagArray.push(bpt171Alarms[index]);
      }
  }
  return  alarmFlagArray.length === 0 ? "No Alarms" : alarmFlagArray.join(", ");;
 
}

const allAlarms151 = [
  "Coil Alarm",
  "Empty pipe Alarm",
  "Negative flow alarm",
  "High flow alarm",
  "Low flow alarm", 
  "Low flow cut off",
  "Pressure Sensor Open",
  "Pressure sensor Short",
  "Pressure over range",
  "Pressure under range",
  "Reserved",
];

export const getAlarmTypeFor151BO = (decAlarmFlag) => {
  let alarmFlagArray = [];

  for (let index = 0; index < allAlarms151.length; index++) {
      if (isBitSet(decAlarmFlag, index)) {
          alarmFlagArray.push(allAlarms151[index]);
      }
  }

  return   alarmFlagArray.length === 0 ? ["No Alarms"] : alarmFlagArray.join(", ");

}

const isBitSet = (no, index) => {
  return ((no >> index) & 0x1) === 1;
}
export const flowUnit = (item) => { 
  console.log("item",item)
  if (item === null) {
    return null; 
  }
  if(item === "0"){
    return  "m³/hr";
  }
  if(item === "1"){
    return  "L/hr";
  }
  if(item === "2"){
    return  "GPM";
  }
  if(item === "3"){
    return  "LPS";
  }
};

const bitAlaramsMapping = {
    0: "INVALID CAPTURE",
    1: "Reserved2 Alarm",
    2: "Reserved3 Alarm",
    3: "Pipe Broken Alarm",
    4: "Reverse flow alarm",
    5: "Empty Pipe Alarm (No Echo)",
    6: "Leak detected Alarm",
    7: "Low Battery Alarm",
    8: "LOG_MEMORY_FULL",
    9: "Data Logger comm. Failed",
    10: "Data Loss Error",
    11: "Config Para Update Failed",
    12: "IP Comm. Fail Error",
    13: "RWM configuration Mode",
    14: "BUP Retry Enable /(Commissioned bit)",
    15: "RWM AM /AMR Mode"
};
const getDynamicDtick = (data) => {
  const maxValue = Math.max(...data.flatMap(trace => trace.y));

  if (maxValue <= 5) return 1;
  if (maxValue <= 100) return 5;
  if (maxValue <= 500) return 100;

  return Math.ceil(maxValue / 10);
};
export const validateBitStatusAlarms = (alarmType) => {
    if (alarmType === "" || alarmType === undefined ||  alarmType === null ) {
        return "None";
    }
    
    if (typeof alarmType === 'string' && !isNaN(alarmType)) {
        alarmType = Number(alarmType);
    }
    
    if (typeof alarmType === 'number') {
        let binaryString = alarmType.toString(2);
        const setBitsCount = binaryString.split('1').length - 1;
        let activeAlarms = [];
        console.log("setBitsCount", setBitsCount);
        activeAlarms.push(bitAlaramsMapping[setBitsCount]);
        return activeAlarms.length > 0 ? activeAlarms : "None";
    }
    return alarmType;
};

export const PieChart = ({ data }) => (
    <Plot
      data={data}
      layout={{
        height: 200,
        width: 230,
        margin: { t: 2, b: 2, l: 0, r: 0 },
        showlegend: false,
        paper_bgcolor: 'transparent',
      }}
    />
  );

  export const LineChart = ({ data,unit }) => (
    <Plot
      data={data}
      layout={{
        height: 500,
        width: '100%',
        xaxis: {
          title: 'Date and time'
        },
        yaxis: {
          title: `Consumption`,
          ticksuffix: unit ? ` ${unit}` : '',
        },
        margin: { t: 20, b: 50, l: 100, r: 10 },
        borderRadius: '15%',
        overflow: 'hidden',
      }}
    />
  );

// export const BarChart = ({ data, unit, reportType, monthValue, fromDate, toDate, dailyFromDate, dailyToDate}) => {
//   const commonLayout = {
//     borderRadius: '15%',
//     overflow: 'hidden',
//   };
//   const PAGE_SIZE = 15;

//   const [pageIndex, setPageIndex] = React.useState(0);
//   const [showAll, setShowAll] = React.useState(false);

//   const xValues = data?.[0]?.x || [];
//   const totalPoints = xValues.length;
//   const totalPages = Math.ceil(totalPoints / PAGE_SIZE);

//   const getPageSlice = () => {
//     if (showAll || reportType !== 'Custom') return data;

//     const start = pageIndex * PAGE_SIZE;
//     const end = start + PAGE_SIZE;

//     return data.map(trace => ({
//       ...trace,
//       x: trace.x.slice(start, end),
//       y: trace.y.slice(start, end),
//       text: trace.text?.slice(start, end)
//     }));
//   };

//   const pagedData = getPageSlice();

//   const goNext = () => {
//     if (pageIndex < totalPages - 1) setPageIndex(p => p + 1);
//   };

//   const goPrev = () => {
//     if (pageIndex > 0) setPageIndex(p => p - 1);
//   };



//   const fromDateValue = fromDate
//   const toDateValue = toDate

//   const generateTitle = () => {
   
    
//     const currentDate = new Date();
//     const formatDate = (date) => {
//       return new Date(date).toLocaleDateString('en-US', { 
//         month: 'short', 
//         day: 'numeric', 
//         year: 'numeric' 
//       });
//     };
    
//     switch(reportType) {
//       case 'Daily':
//         return `Daily Consumption - ${formatDate(dailyFromDate)} to ${formatDate(dailyToDate)}`;
//       case 'Monthly':
//        return `Monthly Consumption - ${monthValue?.label ?? ''}`;
//       case 'Custom':
//          return `Custom Consumption - ${formatDate(fromDateValue)} to ${formatDate(toDateValue)}`;
//       default:
//         return 'Consumption Report';
//     }
//   };

//   const chartTitle = generateTitle();

//   const axisTitleStyle = {
//     font: {
//       size: 14,
//       weight: 'bold'
//     },
//     standoff: 20
//   };

//   const axisTickStyle = {
//     tickfont: {
//       weight: 'bold',
//       size: 12
//     }
//   };

//   const getBarSettings = () => {
//     const dataLength = data?.[0]?.x?.length || 0;
    
//     if (dataLength < 7) {
//       return {
//         bargap: 0.5, 
//         bargroupgap: 0.2
//       };
//     } else {
//       return {
//         bargap: 0.5,
//         bargroupgap: 0.3
//       };
//     }
//   };

//   const barSettings = getBarSettings();

//   const dailyMonthlyLayout = {
//     ...commonLayout,
//     height: 600,
//     width: 1200,
//     xaxis: {
//       title: {
//         text: '<b>Date and Time</b>',
//         ...axisTitleStyle
//       },
//       type: 'category',
//       tickangle: -45,
//       automargin: true,
//       ...axisTickStyle
//     },
//     yaxis: {
//       title: {
//         text: `<b>Consumption${unit ? ` (${unit})` : ''}</b>`,
//         ...axisTitleStyle
//       },
//       type: 'linear',
//       automargin: true,
//       ...axisTickStyle,
//       tickformat: ',.0f',
//       separatethousands: true,
//       hoverformat: ',.0f'
//     },
//     title: {
//       text: chartTitle,
//       x: 0.5,
//       xref: 'paper',
//       font: {
//         size: 18,
//         weight: 'bold'
//       }
//     },
//     margin: { t: 50, b: 100, l: 100, r: 10 },
//     ...barSettings, // Apply dynamic bar settings
//     scene: {
//       camera: {
//         eye: { x: 1.5, y: 1.5, z: 1.2 } 
//       }
//     },
//     transition: {
//       duration: 500,
//       easing: 'cubic-in-out'
//     }
//   };

//   const customLayout = {
//     ...commonLayout,
//     height: 550,
//     width: 1100,
//     xaxis: {
//       title: {
//         text: '<b>Date and Time</b>',
//         ...axisTitleStyle
//       },
//       type: 'category',
//       tickangle: -45,
//       automargin: true,
//       ...axisTickStyle
//     },
//     yaxis: {
//       title: {
//         text: `<b>Consumption${unit ? ` (${unit})` : ''}</b>`,
//         ...axisTitleStyle
//       },
//       type: 'linear',
//       automargin: true,
//       ...axisTickStyle,
//       tickformat: ',.0f',
//       separatethousands: true,
//       hoverformat: ',.0f'
//     },
//     title: {
//       text: chartTitle,
//       x: 0.5,
//       xref: 'paper',
//       font: {
//         size: 18,
//         weight: 'bold'
//       }
//     },
//     margin: { t: 50, b: 100, l: 100, r: 10 },
//     ...barSettings, // Apply dynamic bar settings
//     scene: {
//       camera: {
//         eye: { x: 1.5, y: 1.5, z: 1.2 } 
//       }
//     },
//     transition: {
//       duration: 500,
//       easing: 'cubic-in-out'
//     }
//   };

//   const layout = reportType === 'Custom' ? customLayout : dailyMonthlyLayout;
  
//   const enhancedData = data.map(trace => ({
//     ...trace,
//     marker: {
//       ...trace.marker,
//       line: {
//         width: 2,
//         color: 'rgba(0,0,0,0.7)'
//       }
//     },
//   }));
//   {
//     reportType === 'Custom' && (
//       <div
//         style={{
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center',
//           marginBottom: 10
//         }}
//       >
//         <div style={{ fontWeight: 600 }}>
//           Custom Consumption
//         </div>

//         <div style={{ display: 'flex', gap: 8 }}>
//           {!showAll && (
//             <>
//               <button onClick={goPrev} disabled={pageIndex === 0}>
//                 ◀ Prev
//               </button>

//               <span>
//                 {pageIndex + 1} / {totalPages}
//               </span>

//               <button
//                 onClick={goNext}
//                 disabled={pageIndex === totalPages - 1}
//               >
//                 Next ▶
//               </button>
//             </>
//           )}

//           {showAll && (
//             <button
//               onClick={() => {
//                 setShowAll(false);
//                 setPageIndex(0);
//               }}
//             >
//               ⬅ Back to Paged View
//             </button>
//           )}
//         </div>
//       </div>
//     )
//   }


//   return (
//    <Plot
//   data={pagedData}
//   layout={{
//     ...layout,
//     xaxis: {
//       ...layout.xaxis,
//       autorange: showAll || reportType !== 'Custom'
//     }
//   }}
//   config={{
//     displayModeBar: true,
//     displaylogo: false
//   }}
//   onDoubleClick={() => {
//     if (reportType === 'Custom') setShowAll(true);
//   }}
// />

//   );
// };


export const BarChart = ({
  data,
  unit,
  reportType,
  monthlyFromValue,
  monthlyToValue,
  fromDate,
  toDate,
  dailyFromDate,
  dailyToDate
}) => {

  const [pageSize, setPageSize] = React.useState(15); // Changed from const to state
  const [pageIndex, setPageIndex] = React.useState(0);
  const [showAll, setShowAll] = React.useState(false);

  /* ---------------- PAGINATION (DAILY & CUSTOM) ---------------- */

  // Get x values from data - ensure we handle datetime data properly
  const xValues = React.useMemo(() => {
    if (!data || data.length === 0) return [];
    
    // For daily reports with datetime data, we need to count the actual points
    const firstTrace = data[0];
    if (firstTrace.x && Array.isArray(firstTrace.x)) {
      return firstTrace.x;
    }
    return [];
  }, [data]);

  const totalPoints = xValues.length;
  const totalPages = Math.ceil(totalPoints / pageSize); // Use pageSize state
  
  // Calculate current range for display
  const currentStart = pageIndex * pageSize; // Use pageSize state
  const currentEnd = Math.min(currentStart + pageSize, totalPoints); // Use pageSize state

  const pagedData = React.useMemo(() => {
    // Show all data for Monthly or when showAll is true
    if (reportType === 'Monthly' || showAll) return data;

    const start = pageIndex * pageSize; // Use pageSize state
    const end = start + pageSize; // Use pageSize state

    return data.map(trace => ({
      ...trace,
      x: trace.x.slice(start, end),
      y: trace.y.slice(start, end),
      text: trace.text?.slice(start, end),
      // For daily reports, we might need to preserve datetime formatting
      ...(reportType === 'Daily' && {
        xaxis: 'x',
        type: 'bar'
      })
    }));
  }, [data, pageIndex, showAll, reportType, pageSize]); // Add pageSize dependency

  /* ---------------- HANDLE PAGE SIZE CHANGE ---------------- */
  
  const handlePageSizeChange = (newSize) => {
    const newPageSize = parseInt(newSize, 10);
    setPageSize(newPageSize);
    
    // Recalculate page index to show approximately the same data
    const newStartIndex = Math.floor((currentStart) / newPageSize);
    setPageIndex(Math.min(newStartIndex, Math.ceil(totalPoints / newPageSize) - 1));
  };

  /* ---------------- TITLE WITH PAGINATION INFO ---------------- */

  const formatDate = (date) =>
    new Date(date).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });

  const formatDateTimeForTitle = (value) => {
    if (!value) return '';
    
    // Try to parse as date
    const date = new Date(value);
    if (!isNaN(date.getTime())) {
      return date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric'
      });
    }
    return value;
  };

  const chartTitle = (() => {
    const baseTitle = (() => {
      switch (reportType) {
        case 'Daily':
          return `Daily Consumption - ${formatDate(dailyFromDate)} to ${formatDate(dailyToDate)}`;
        case 'Monthly':
          return `Monthly Consumption - ${formatDate(monthlyFromValue)} to ${formatDate(monthlyToValue)}`;
        case 'Custom':
          return `Custom Consumption - ${formatDate(fromDate)} to ${formatDate(toDate)}`;
        default:
          return 'Consumption Report';
      }
    })();

    // Add pagination info for daily/custom reports when not showing all
    if ((reportType === 'Daily' || reportType === 'Custom') && !showAll && totalPoints > 0) {
      const startDate = formatDateTimeForTitle(xValues[currentStart]);
      const endDate = formatDateTimeForTitle(xValues[currentEnd - 1]);
      
      // if (startDate && endDate) {
      //   return `${baseTitle} (Showing ${startDate} to ${endDate})`;
      // }
    }

    return baseTitle;
  })();

  /* ---------------- PAGINATION CONTROLS & NAVIGATION ---------------- */

  const goNext = () => {
    if (pageIndex < totalPages - 1) setPageIndex(p => p + 1);
  };

  const goPrev = () => {
    if (pageIndex > 0) setPageIndex(p => p - 1);
  };

  const resetToFirstPage = () => {
    setPageIndex(0);
    setShowAll(false);
  };

  const goToFirstPage = () => {
    setPageIndex(0);
  };

  const goToLastPage = () => {
    setPageIndex(totalPages - 1);
  };

  /* ---------------- LAYOUTS ---------------- */

  const axisTitleStyle = {
    font: { size: 14, weight: 'bold' },
    standoff: 20
  };

  const axisTickStyle = {
    tickfont: { size: 12, weight: 'bold' }
  };

  const commonLayout = {
    borderRadius: '15%',
    overflow: 'hidden',
    transition: { duration: 500, easing: 'cubic-in-out' }
  };

  // Dynamic bar settings based on number of points
 // Dynamic bar settings based on number of points
const getBarSettings = (pointsCount) => {
  if (pointsCount === 1 || pointsCount === 2 || pointsCount === 3) {
    return {
      bargap: 0.9,
      bargroupgap: 0.1,

      ...(reportType === "Custom"
        ? {
            xaxis: {
              title: {
                text: '<b>Meter Serial Number</b>',
                ...axisTitleStyle
              },
              type: 'category',
              tickangle: -45,
              automargin: true,
              ...axisTickStyle,
              autorange: false,
              range: [-0.5, 0.5] 
            }
          }
        : {
            xaxis: {
                title: {
                text: '<b>Date and Time</b>',
                ...axisTitleStyle
              },
              autorange: false,
            type: 'category',
            tickangle: -45,
            automargin: true,
            ...axisTickStyle,
            autorange: false,
              range: [-0.5, 0.5] 
            }
          })
    };
  }

  return {
    bargap: pointsCount > 30 ? 0.1 : 0.5,
    bargroupgap: pointsCount > 30 ? 0.05 : 0.1
  };
};


  // DAILY LAYOUT - optimized for datetime x-axis
  const dailyLayout = {
    ...commonLayout,
    height: 550,
    width: 1400,
    xaxis: {
      title: { text: '<b>Date and Time</b>', ...axisTitleStyle },
      type: 'category',
      tickangle: -45,
      automargin: true,
      tickmode: 'array',
      tickvals: pagedData[0]?.x || [],
      ticktext: pagedData[0]?.x?.map(date => {
        try {
          return new Date(date).toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric'
          });
        } catch {
          return date;
        }
      }) || [],
      ...axisTickStyle
    },
    yaxis: {
      title: {
        text: `<b>Consumption${unit ? ` (${unit})` : ''}</b>`,
        ...axisTitleStyle
      },
      tickformat: ',.0f',
      separatethousands: true,
      ...axisTickStyle
    },
    title: {
      text: chartTitle,
      x: 0.5,
      font: { size: 18, weight: 'bold' }
    },
    margin: { t: 50, b: 120, l: 100, r: 10 },
    ...getBarSettings(pagedData[0]?.x?.length || 0)
  };

  // CUSTOM LAYOUT - for meter serial numbers
  const customLayout = {
    ...commonLayout,
    height: 550,
    width: 1400,
    xaxis: {
      title: {
        text: '<b>Meter Serial Number</b>',
        ...axisTitleStyle
      },
      type: 'category',
      tickangle: -45,
      automargin: true,
      ...axisTickStyle
    },
    yaxis: {
      title: {
        text: `<b>Consumption${unit ? ` (${unit})` : ''}</b>`,
        ...axisTitleStyle
      },
      type: 'linear',
      automargin: true,
      ...axisTickStyle,
      tickformat: ',.0f',
      separatethousands: true,
      hoverformat: ',.0f'
    },
    title: {
      text: chartTitle,
      x: 0.5,
      xref: 'paper',
      font: { size: 18, weight: 'bold' }
    },
    margin: { t: 50, b: 120, l: 100, r: 10 },
    ...getBarSettings(pagedData[0]?.x?.length || 0)
  };

  // Determine layout based on report type
  const layout = (() => {
    switch (reportType) {
      case 'Daily':
        return dailyLayout;
      case 'Custom':
        return customLayout;
      default:
        return dailyLayout; // Default fallback
    }
  })();

  const enhancedData = pagedData.map(trace => ({
    ...trace,
    marker: {
      ...trace.marker,
      line: { width: 2, color: 'rgba(0,0,0,0.7)' }
    }
  }));

  /* ---------------- STYLE VALUES ---------------- */
  
  const btnValue = {
    padding: '8px 16px',
    border: '1px solid #d1d5db',
    borderRadius: '6px',
    background: 'white',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500',
    transition: 'all 0.2s',
    minWidth: '100px',
    ':hover:not(:disabled)': {
      background: '#f3f4f6',
      borderColor: '#9ca3af'
    },
    ':disabled': {
      opacity: 0.5,
      cursor: 'not-allowed'
    }
  };

  const pageInfoValue = {
    padding: '6px 12px',
    fontSize: '14px',
    fontWeight: '500',
    display: 'flex',
    alignItems: 'center',
    color: '#374151'
  };

  /* ---------------- RENDER ---------------- */

  return (
    <div>
      {/* -------- PAGINATION CONTROLS (DAILY & CUSTOM) -------- */}
      {(reportType === 'Daily' || reportType === 'Custom') && totalPoints > 0 && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 10,
            padding: '8px 12px',
            background: '#f8f9fa',
            borderRadius: '8px',
            border: '1px solid #e9ecef'
          }}
        >
          <div style={{ fontWeight: 600, fontSize: '14px' }}>
            {reportType} Consumption
            <span style={{ marginLeft: '10px', color: '#666', fontSize: '12px' }}>
              {!showAll ? (
                `Showing ${currentStart + 1}-${currentEnd} of ${totalPoints} entries`
              ) : (
                `Showing all ${totalPoints} entries`
              )}
            </span>
          </div>

          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            {!showAll ? (
              <>
                <button 
                  style={btnValue} 
                  onClick={goToFirstPage} 
                  disabled={pageIndex === 0}
                  title="Go to first page"
                >
                  « First
                </button>
                
                <button 
                  style={btnValue} 
                  onClick={goPrev} 
                  disabled={pageIndex === 0}
                >
                  ◀ Prev
                </button>

                <span style={pageInfoValue}> 
                  Page {pageIndex + 1} of {totalPages}
                </span>

                <button 
                  style={btnValue}
                  onClick={goNext}
                  disabled={pageIndex === totalPages - 1}
                >
                  Next ▶
                </button>

                <button 
                  style={btnValue}
                  onClick={goToLastPage}
                  disabled={pageIndex === totalPages - 1}
                  title="Go to last page"
                >
                  Last »
                </button>

                {totalPoints > pageSize && (
                  <button 
                    style={{ 
                      ...btnValue, 
                      background: '#4f46e5', 
                      color: 'white',
                      borderColor: '#4f46e5',
                      marginLeft: '8px'
                    }}
                    onClick={() => setShowAll(true)}
                  >
                    Show All
                  </button>
                )}
              </>
            ) : (
              <>
                <button 
                  style={{ 
                    ...btnValue, 
                    background: '#6b7280', 
                    color: 'white',
                    borderColor: '#6b7280'
                  }}
                  onClick={resetToFirstPage}
                >
                  Back to Paged View
                </button>
                
                <span style={pageInfoValue}>
                  Showing all data
                </span>
              </>
            )}
          </div>
        </div>
      )}

      {/* ---------------- CHART ---------------- */}
      <div style={{ 
        border: '1px solid #e5e7eb', 
        borderRadius: '8px', 
        padding: '10px',
        background: 'white',
        boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)'
      }}>
        <Plot
          data={enhancedData}
          layout={{
            ...layout,
            xaxis: {
              ...layout.xaxis,
              autorange: true
            }
          }}
          config={{
            displayModeBar: true,
            displaylogo: false,
            responsive: true
          }}
          onDoubleClick={() => {
            if ((reportType === 'Daily' || reportType === 'Custom') && totalPoints > pageSize) {
              setShowAll(true);
            }
          }}
          style={{ width: '100%', height: '100%' }}
        />
      </div>

      {/* -------- PAGE SIZE SELECTOR -------- */}
      {(reportType === 'Daily' || reportType === 'Custom') && !showAll && totalPoints > 0 && (
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginTop: '10px',
          padding: '8px 12px',
          background: '#f8f9fa',
          borderRadius: '6px',
          border: '1px solid #e5e7eb'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ fontSize: '14px', color: '#374151', fontWeight: '500' }}>
              Page Size:
            </span>
            <select 
              value={pageSize}
              onChange={(e) => handlePageSizeChange(e.target.value)}
              style={{
                padding: '6px 12px',
                borderRadius: '4px',
                border: '1px solid #d1d5db',
                fontSize: '14px',
                background: 'white',
                cursor: 'pointer',
                outline: 'none',
                minWidth: '80px'
              }}
            >
              <option value={5}>5 items</option>
              <option value={10}>10 items</option>
              <option value={15}>15 items</option>
              <option value={20}>20 items</option>
              <option value={30}>30 items</option>
              <option value={50}>50 items</option>
            </select>
            
            <span style={{ marginLeft: '10px', fontSize: '12px', color: '#6b7280' }}>
              Total: {totalPoints} entries
            </span>
          </div>
          
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ fontSize: '12px', color: '#6b7280' }}>
              Jump to page:
            </span>
            <input
              type="number"
              min="1"
              max={totalPages}
              value={pageIndex + 1}
              onChange={(e) => {
                const newPage = parseInt(e.target.value, 10);
                if (newPage >= 1 && newPage <= totalPages) {
                  setPageIndex(newPage - 1);
                }
              }}
              style={{
                width: '60px',
                padding: '4px 8px',
                borderRadius: '4px',
                border: '1px solid #d1d5db',
                fontSize: '14px',
                textAlign: 'center'
              }}
            />
            <span style={{ fontSize: '12px', color: '#6b7280' }}>
              of {totalPages}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export const LineChartAllSelecetdOneMeter = ({ data }) => {
  const dtickValue = getDynamicDtick(data);

  return (
    <Plot
      data={data.map(trace => ({
        ...trace,
        type: "bar",
      }))}
      layout={{
        height: 300,
        width: 550,
        yaxis: {
          title: "Meters",
          gridcolor: "rgba(0,0,0,0.1)",
          dtick: dtickValue,
          tickformat: "d",
        },
        margin: { t: 20, b: 35, l: 50, r: 20 },
        barmode: "group",
        bargap: 0.3,
        paper_bgcolor: "transparent",
        plot_bgcolor: "transparent",
        showlegend: true,
      }}
    />
  );
};



 export const LineChartAllMeters = ({ data }) => {
  const dtickValue = getDynamicDtick(data);

  return (
    <Plot
      data={data.map(trace => ({
        ...trace,
        type: "bar",
      }))}
      layout={{
        height: 300,
        width: 550,
        yaxis: {
          title: "Meters",
          gridcolor: "rgba(0,0,0,0.1)",
          dtick: dtickValue,
          tickformat: "d",
        },
        margin: { t: 20, b: 35, l: 60, r: 5 },
        barmode: "group",
        bargap: 0.3,
        paper_bgcolor: "transparent",
        plot_bgcolor: "transparent",
        showlegend: true,
      }}
      config={{ responsive: true }}
    />
  );
};

 export const LineChartAllMetersBig = ({ data }) => {
  const dtickValue = getDynamicDtick(data);

  return (
    <Plot
      data={data.map(trace => ({
        ...trace,
        type: "bar",
      }))}
      layout={{
        height: 300,
        width: 800,
        yaxis: {
          title: "Meters",
          dtick: dtickValue,
          tickformat: "d",
        },
        margin: { t: 20, b: 20, l: 55, r: 20 },
      }}
      config={{ responsive: true }}
    />
  );
};


export const LineChartTotalizer = ({ data, unit, reportType, monthValue, fromDate, toDate, dailyFromDate, dailyToDate}) => {
  const commonLayout = {
    borderRadius: '15%',
    overflow: 'hidden',
  };

  const fromDateValue = fromDate
  const toDateValue = toDate

  const generateTitle = () => {
    const currentDate = new Date();
    const formatDate = (date) => {
      return new Date(date).toLocaleDateString('en-US', { 
        month: 'short', 
        day: 'numeric', 
        year: 'numeric' 
      });
    };
    
    switch(reportType) {
      case 'Daily':
        return `Totalizer Daily Consumption - ${formatDate(dailyFromDate)} to ${formatDate(dailyToDate)}`;
      case 'Monthly':
       return `Totalizer Monthly Consumption - ${monthValue?.label ?? ''}`;
      case 'Custom':
         return `Totalizer Custom Consumption - ${formatDate(fromDateValue)} to ${formatDate(toDateValue)}`;
      default:
        return 'TOTALIZER';
    }
  };

  const chartTitle = generateTitle();

  const axisTitleStyle = {
    font: {
      size: 14,
      weight: 'bold'
    },
    standoff: 20
  };

  const axisTickStyle = {
    tickfont: {
      weight: 'bold',
      size: 12
    }
  };

  const dailyMonthlyLayout = {
    ...commonLayout,
    height: 600,
    width: 1100,
    xaxis: {
      title: {
        text: '<b>Date and Time</b>',
        ...axisTitleStyle
      },
      type: 'category',
      tickangle: -45,
      automargin: true,
      ...axisTickStyle
    },
    yaxis: {
      title: {
        text: `<b>Consumption${unit ? ` (${unit})` : ''}</b>`,
        ...axisTitleStyle
      },
      type: 'linear',
      automargin: true,
      ...axisTickStyle,
      tickformat: ',.0f',
      separatethousands: true,
      hoverformat: ',.0f'
    },
    title: {
      text: chartTitle,
      x: 0.5,
      xref: 'paper',
      font: {
        size: 18,
        weight: 'bold'
      }
    },
    margin: { t: 50, b: 100, l: 100, r: 10 },
    bargap: 0.5,
    scene: {
      camera: {
        eye: { x: 1.5, y: 1.5, z: 1.2 } 
      }
    },
    transition: {
      duration: 500,
      easing: 'cubic-in-out'
    }
  };

  const customLayout = {
    ...commonLayout,
    height: 600,
    width: 1100,
    xaxis: {
      title: {
        text: '<b>Meter Serial Number</b>',
        ...axisTitleStyle
      },
      type: 'category',
      tickangle: -45,
      automargin: true,
      ...axisTickStyle
    },
    yaxis: {
      title: {
        text: `<b>Consumption${unit ? ` (${unit})` : ''}</b>`,
        ...axisTitleStyle
      },
      type: 'linear',
      automargin: true,
      ...axisTickStyle,
      tickformat: ',.0f',
      separatethousands: true,
      hoverformat: ',.0f'
    },
    title: {
      text: chartTitle,
      x: 0.5,
      xref: 'paper',
      font: {
        size: 18,
        weight: 'bold'
      }
    },
    margin: { t: 50, b: 100, l: 100, r: 10 },
    bargap: 0.5,
    scene: {
      camera: {
        eye: { x: 1.5, y: 1.5, z: 1.2 } 
      }
    },
    transition: {
      duration: 500,
      easing: 'cubic-in-out'
    }
  };

  const layout = reportType === 'Custom' ? customLayout : dailyMonthlyLayout;
  const enhancedData = data.map(trace => ({
    ...trace,
    line: {
      ...trace.line,
      width: 3,
      shape: 'spline', 
    },
    marker: {
      size: 6,
      line: {
        width: 2,
        color: 'rgba(0,0,0,0.7)'
      }
    },
    hoverinfo: 'x+y+text',
    hoverlabel: {
      bgcolor: 'rgba(0,0,0,0.8)',
      font: {
        size: 14,
        color: 'white'
      }
    }
  }));

  return (
    <Plot
      data={enhancedData}
      layout={layout}
      config={{
        displayModeBar: true,
        displaylogo: false,
        modeBarButtonsToRemove: ['pan2d', 'lasso2d', 'select2d', 'autoScale2d'],
        modeBarButtonsToAdd: ['hoverClosestGl2d'],
        plotGlPixelRatio: 2,
        transition: {
          duration: 500,
          easing: 'cubic-in-out'
        }
      }}
    />
  );
};

// export const LineChartFlowrate = ({ data }) => {
//   const axisTitleStyle = {
//     font: {
//       size: 14,
//       weight: 'bold'
//     },
//     standoff: 20
//   };

//   const axisTickStyle = {
//     tickfont: {
//       weight: 'bold',
//       size: 12
//     }
//   };

//   const enhancedData = data.map(trace => ({
//     ...trace,
//     line: {
//       ...trace.line,
//       width: 3,
//       shape: 'spline',
//     },
    
//     marker: {
//       size: 6,
//       line: {
//         width: 2,
//         color: 'rgba(0,0,0,0.7)'
//       }
//     },
   
//     hoverinfo: 'x+y+text',
//     hoverlabel: {
//       bgcolor: 'rgba(0,0,0,0.8)',
//       font: {
//         size: 14,
//         color: 'white'
//       }
//     }
//   }));

//   return (
//     <Plot
//       data={enhancedData}
//       layout={{
//         height: 450,
//         width: 1100,
//         xaxis: {
//           title: {
//             text: '<b>Date and Time</b>',
//             ...axisTitleStyle
//           },
//           ...axisTickStyle
//         },
//         yaxis: {
//           title: {
//             text: '<b>Flowrate</b>',
//             ...axisTitleStyle
//           },
//           ...axisTickStyle,
//           separatethousands: true,
//           hoverformat: ',.3f'
//         },
//         title: {
//           text: '<b>FLOWRATE</b>',
//           x: 0.5,
//           xref: 'paper',
//           font: {
//             size: 18,
//             weight: 'bold'
//           }
//         },
//         margin: { t: 50, b: 100, l: 80, r: 10 }, 
//         borderRadius: '15%',
//         overflow: 'hidden',
//         scene: {
//           camera: {
//             eye: { x: 1.5, y: 1.5, z: 1.2 } 
//           }
//         },
//         transition: {
//           duration: 500,
//           easing: 'cubic-in-out'
//         }
//       }}
//       config={{
//         plotGlPixelRatio: 2,
//         transition: {
//           duration: 500,
//           easing: 'cubic-in-out'
//         },
//         displayModeBar: true,
//         displaylogo: false,
//         modeBarButtonsToRemove: ['pan2d', 'lasso2d', 'select2d', 'autoScale2d'],
//         modeBarButtonsToAdd: ['hoverClosestGl2d']
//       }}
//     />
//   );
// };

  const markers = [
    { lat: 18.516726, lng: 73.856255 }, // Pune City Center
    { lat: 18.530823, lng: 73.855202 }, // Shivajinagar
    { lat: 18.500000, lng: 73.800000 }, // Kothrud
    { lat: 18.5861, lng: 73.7490 },     // Hinjewadi IT Park
    { lat: 18.5773, lng: 73.9190 },     // Pune International Airport
    { lat: 18.4092, lng: 73.8300 },     // Sinhagad Fort
    { lat: 18.5300, lng: 73.8950 },     // Aga Khan Palace
    { lat: 18.5584, lng: 73.9250 }      // Viman Nagar
];
  const markerss = [
    { lat: -24.397, lng: 150.644 },
  ];

  const Tooltip = ({ text, position, hovered, status }) => {
    console.log("text::", text);
    console.log("position::", position);
  
    return (
      <OverlayView
        position={position}
        mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
        getPixelPositionOffset={(width, height) => ({
          x: -(width / 2),
          y: -(height + 10),
        })}
      >
        <div style={{
          background: 'black',
          color: 'white',
          border: '1px solid black',
          padding: '5px',
          zIndex: 1000,
          fontSize: hovered ? '20px' : '12px', 
          transition: 'font-size 0.2s ease' 
        }}>
           {`Meter serial no : ${text}, ${status}`}
        </div>
      </OverlayView>
    );
  };

  const MyMapComponent = withScriptjs(withGoogleMap(({ meterMapReadings }) => {
    console.log("meterMapReadings::",meterMapReadings)
    const [tooltip, setTooltip] = useState({ visible: false, text: '', position: {}, hovered: false, status: '' });
    const [exportBox, setExportBox] = useState({ visible: false, serialNumber: '', position: {} });
  
    const history = useHistory();
    const infoBoxCliked = (serialNumber, meterType) => {
      if (window.confirm("Are you sure you want to see details of the selected meter?")) {
        const rowItem = serialNumber ? { serial_number: serialNumber } : null;
  
        history.push({
          pathname: "/meter-reading",
          state: { rowItem, pageName: meterType === "Flow" ? "Flow Readings" : meterType === "Level" ? "Level Readings" : meterType === "Pressure" ? "Pressure Readings" : "Flow Readings", pathName: meterType === "Flow" ? "flow-readings-page" : meterType === "Level" ? "level-readings-page" : meterType === "Pressure" ? "pressure-readings-page" : "flow-readings-page" },
        });
      }
    };
  
    const MapViewReadings = meterMapReadings.meterMapReadings
      .map((marker) => ({
        latitude: parseFloat(marker.gps_latitude),
        longitude: parseFloat(marker.gps_longitude),
        serialNumber: marker.serial_number,
        meterType: marker.meter_type,
        meterStatus: marker.status
      }))
      .filter((item) => !isNaN(item.latitude) && !isNaN(item.longitude));
  
    const defaultCenter = MapViewReadings.length > 0
      ? { lat: MapViewReadings[0].latitude, lng: MapViewReadings[0].longitude }
      : { lat: 22.00, lng: 77.00 };
    return (
      <GoogleMap defaultZoom={defaultCenter.lat === 22.00 ? 4 : 10} defaultCenter={defaultCenter}>
        {MapViewReadings.map((marker, index) => (
          <Marker
            key={index}
            position={{ lat: marker.latitude, lng: marker.longitude }}
            onMouseOver={() => setTooltip({
              visible: true,
              status: marker.meterStatus,
              text: marker.serialNumber,
              meterType: marker.meterType,
              position: { lat: marker.latitude, lng: marker.longitude },
              hovered: true
            })}
            onMouseOut={() => setTooltip({ visible: false, text: '', position: {}, status: '' })}
            onClick={() => setExportBox({
              visible: true,
              serialNumber: marker.serialNumber,
              meterType: marker.meterType,
              position: { lat: marker.latitude, lng: marker.longitude }
            })}
          />
        ))}
  
        {tooltip.visible && (
          <OverlayView
            position={tooltip.position}
            mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
          >
            <div style={{ backgroundColor: "#fff", padding: "5px", border: "1px solid black", borderRadius: "5px" }}>
              <strong>Serial No:</strong> {tooltip.text} <br />
              <strong>Status:</strong> {tooltip.status}
            </div>
          </OverlayView>
        )}
  
        {exportBox.visible && (
          <OverlayView
            position={exportBox.position}
            mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
          >
            <div
              style={{
                background: '#fff',
                padding: '10px',
                border: '1px solid #ccc',
                borderRadius: '5px',
                position: "relative",
                transform: "translate(-50%, -100%)",
                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)"
              }}
            >
              <button onClick={() => infoBoxCliked(exportBox.serialNumber, exportBox.meterType)}>Export Data</button>
              <p>Meter Serial: {exportBox.serialNumber}</p>
              <button onClick={() => setExportBox({ visible: false })}>Close</button>
            </div>
          </OverlayView>
        )}
      </GoogleMap>
    );
  }));
  
  export const WrappedMap = (meterMapReadings) => (
    <MyMapComponent
      meterMapReadings={meterMapReadings}
      googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAP_API_KEY}&v=3.exp&libraries=geometry,drawing,places`}
      loadingElement={<div style={{ height: '100%' }} />}
      containerElement={<div style={{ height: '500px', width: '100%' }} />}
      mapElement={<div style={{ height: '100%' }} />}
    />
  );

  export const pieDataOne = [{
    values: [55, 19, 10],
    labels: ['Active', 'Inactive', 'Faulty'],
    type: 'pie',
    textinfo: 'label+value',
    hoverinfo: 'label+value',
    marker: {
      colors: ['#DFF1FF', '#FEE7DA', '#FEF7D9'],
      line: {
        color: '#aaa',
        width: 1
      }
    }
  }];

  export const pieDataTwo = [{
    values: [25, 15, 9],
    labels: ['Active', 'Inactive', 'Faulty'],
    type: 'pie',
    textinfo: 'label+value',
    hoverinfo: 'label+value',
    marker: {
      colors: ['#DFF1FF', '#FEE7DA', '#FEF7D9'],
      line: {
        color: '#aaa',
        width: 1
      }
    }
  }];


  export const pieDataThree = [{
    values: [45, 19, 12],
    labels: ['Active', 'Inactive', 'Faulty'],
    type: 'pie',
    textinfo: 'label+value',
    hoverinfo: 'label+value',
    marker: {
      colors: ['#DFF1FF', '#FEE7DA', '#FEF7D9'],
      line: {
        color: '#aaa',
        width: 1
      }
    }
  }];


  export const pieDataFour = [{
    values: [25, 9, 3],
    labels: ['Active', 'Inactive', 'Faulty'],
    type: 'pie',
    textinfo: 'label+value',
    hoverinfo: 'label+value',
    marker: {
      colors: ['#DFF1FF', '#FEE7DA', '#FEF7D9'],
      line: {
        color: '#aaa',
        width: 1
      }
    }
  }];

  
export const lineDataOne = [{
  x: ['2025-01-23', '2025-01-24', '2025-01-25', '2025-01-26', '2025-01-27', '2025-01-28', '2025-01-29'],
  y: [10, 15, 13, 17, 34, 50, 70, 100],
  mode: 'lines+markers',
  marker: { color: "1f77b4" },
  line: { color: '#1f77b4' },
  borderRadius: '45%',
  name: "Active"
}, {
  x: ['2025-01-23', '2025-01-24', '2025-01-25', '2025-01-26', '2025-01-27', '2025-01-28', '2025-01-29'],
  y: [10, 15, 13, 15, 32, 40, 80, 100],
  mode: 'lines+markers',
  marker: { color: 'red' },
  line: { color: 'red' },
  borderRadius: '45%',
  name: "Inactive"
}, {
  x:['2025-01-23', '2025-01-24', '2025-01-25', '2025-01-26', '2025-01-27', '2025-01-28', '2025-01-29'],
  y: [0, 1, 1, 1, 1, 1, 1, 1],
  mode: 'lines+markers',
  marker: { color: 'orange' },
  line: { color: 'orange' },
  borderRadius: '45%',
  name: "Faulty"
}];

export const lineDataTwo = [{
  x: ['2024-11-01', '2024-11-02', '2024-11-03', '2024-11-04'],
  y: [20, 35, 43, 55],
  type: 'scatter',
  mode: 'lines+markers',
  marker: { color: '#1f77b4' },
  line: { color: '#1f77b4' },
  borderRadius: '45%',
  name: "Active"
},
{
  x: ['2024-11-01', '2024-11-02', '2024-11-03', '2024-11-04'],
  y: [20, 30, 40, 50],
  type: 'scatter',
  mode: 'lines+markers',
  marker: { color: 'red' },
  line: { color: 'red' },
  borderRadius: '45%',
  name: "Inactive"
},
{
  x: ['2024-11-01', '2024-11-02', '2024-11-03', '2024-11-04'],
  y: [0, 1, 2, 5],
  type: 'scatter',
  mode: 'lines+markers',
  marker: { color: 'orange' },
  line: { color: 'orange' },
  borderRadius: '45%',
  name: "Faulty"
}];

export const lineDataThree = [{
  x: ['2024-10-01', '2024-10-12', '2024-10-23', '2024-10-28'],
  y: [20, 35, 45, 58],
  type: 'scatter',
  mode: 'lines+markers',
  marker: { color: 'red' },
  line: { color: 'red' },
  borderRadius: '45%',
  name: "Active"
},
{
  x: ['2024-10-01', '2024-10-12', '2024-10-23', '2024-10-28'],
  y: [10, 25, 40, 57],
  type: 'scatter',
  mode: 'lines+markers',
  marker: { color: '#1f77b4' },
  line: { color: '#1f77b4' },
  borderRadius: '45%',
  name: "Inactive"
},
{
  x: ['2024-10-01', '2024-10-12', '2024-10-23', '2024-10-28'],
  y: [0, 3, 3, 7],
  type: 'scatter',
  mode: 'lines+markers',
  marker: { color: 'orange' },
  line: { color: 'orange' },
  borderRadius: '45%',
  name: "Faulty",
}];
export const lineDataFour = [{
  x: ['2024-10-01', '2024-10-02', '2024-10-03', '2024-10-04'],
  y: [30, 15, 19, 47],
  type: 'scatter',
  mode: 'lines+markers',
  marker: { color: '#1f77b4' },
  line: { color: '#1f77b4' },
  borderRadius: '45%',
  name: "Active"
},
{
  x: ['2024-10-01', '2024-10-02', '2024-10-03', '2024-10-04'],
  y: [40, 15, 69, 87],
  type: 'scatter',
  mode: 'lines+markers',
  marker: { color: 'red' },
  line: { color: 'red' },
  borderRadius: '45%',
  name: "Inactive"
},
{
  x: ['2024-10-01', '2024-10-02', '2024-10-03', '2024-10-04'],
  y: [0, 1, 1, 1],
  type: 'scatter',
  mode: 'lines+markers',
  marker: { color: 'orange' },
  line: { color: 'orange' },
  borderRadius: '45%',
  name: "Faulty"
}];

  const MyMapComponents = withScriptjs(withGoogleMap(() => (
    <GoogleMap
      defaultZoom={12}
      defaultCenter={{  lat: 18.516726, lng: 73.856255}}
    >
      {markers.map((marker, index) => (
          <Marker style={{backgroundColor:"blue"}}
            key={index} 
            position={{ lat: marker.lat, lng: marker.lng }} 
          />
        ))}
        {markers.map((marker, index) => (
          <Marker style={{backgroundColor:"blue"}}
            key={index} 
            position={{ lat: marker.lat, lng: marker.lng }} 
          />
        ))}
    </GoogleMap>
  )));
  
  export const WrappedMapAllMeters = () => (
    <MyMapComponents
      googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAP_API_KEY}&v=3.exp&libraries=geometry,drawing,places`}
      loadingElement={<div style={{ height: '100%' }} />}
      containerElement={<div style={{ height: '500px', width: '100%' }} />}
      mapElement={<div style={{ height: '100%' }} />}
    />
  );

// export const LevellineChart = ({ data }) => {
//   const axisTitleStyle = {
//     font: {
//       size: 14,
//       weight: 'bold'
//     },
//     standoff: 20
//   };

//   const axisTickStyle = {
//     tickfont: {
//       weight: 'bold',
//       size: 12
//     }
//   };

//   const enhancedData = data.map(trace => ({
//     ...trace,
//     line: {
//       ...trace.line,
//       width: 3,
//       shape: 'spline',
//     },
    
//     marker: {
//       size: 6,
//       line: {
//         width: 2,
//         color: 'rgba(0,0,0,0.7)'
//       }
//     },
   
//     hoverinfo: 'x+y+text',
//     hoverlabel: {
//       bgcolor: 'rgba(0,0,0,0.8)',
//       font: {
//         size: 14,
//         color: 'white'
//       }
//     }
//   }));

//   return (
//     <Plot
//       data={enhancedData}
//       layout={{
//         height: 550,
//         width: 1500,
//         xaxis: {
//           title: {
//             text: '<b>Date and Time</b>',
//             ...axisTitleStyle
//           },
//           ...axisTickStyle
//         },
//         yaxis: {
//           title: {
//             text: '<b>Level</b>',
//             ...axisTitleStyle
//           },
//           ...axisTickStyle,
//           separatethousands: true,
//           hoverformat: ',.3f'
//         },
//         title: {
//           text: '<b>LEVEL</b>',
//           x: 0.5,
//           xref: 'paper',
//           font: {
//             size: 18,
//             weight: 'bold'
//           }
//         },
//         margin: { t: 50, b: 100, l: 80, r: 10 }, 
//         borderRadius: '15%',
//         overflow: 'hidden',
//         scene: {
//           camera: {
//             eye: { x: 1.5, y: 1.5, z: 1.2 } 
//           }
//         },
//         transition: {
//           duration: 500,
//           easing: 'cubic-in-out'
//         }
//       }}
//       config={{
//         plotGlPixelRatio: 2,
//         transition: {
//           duration: 500,
//           easing: 'cubic-in-out'
//         },
//         displayModeBar: true,
//         displaylogo: false,
//         modeBarButtonsToRemove: ['pan2d', 'lasso2d', 'select2d', 'autoScale2d'],
//         modeBarButtonsToAdd: ['hoverClosestGl2d']
//       }}
//     />
//   );
// };

// import React, { useState, useMemo } from "react";
// import Plot from "react-plotly.js";

// import React, { useState, useMemo } from "react";
// import Plot from "react-plotly.js";



export const LevellineChart = ({ data }) => {
  const PAGE_SIZE = 96;

  const axisTitleStyle = {
    font: { size: 14, weight: "bold" },
    standoff: 20
  };

  const axisTickStyle = {
    tickfont: { size: 12, weight: "bold" }
  };

  const [pageIndex, setPageIndex] = useState(0);
  const [showAll, setShowAll] = useState(false);

  const sortTraceByX = (trace) => {
    if (!trace?.x || !trace?.y) return trace;

    const combined = trace.x.map((x, i) => ({
      x,
      y: trace.y[i],
      text: trace.text?.[i]
    }));

    combined.sort((a, b) => new Date(a.x) - new Date(b.x));

    return {
      ...trace,
      x: combined.map(p => p.x),
      y: combined.map(p => p.y),
      text: combined.map(p => p.text)
    };
  };

  const sortedData = useMemo(
    () => data.map(sortTraceByX),
    [data]
  );

  const xValues = sortedData?.[0]?.x || [];
  const totalPoints = xValues.length;
  const totalPages = Math.ceil(totalPoints / PAGE_SIZE);

  const addPadding = (startX, endX) => {
    const start = new Date(startX).getTime();
    const end = new Date(endX).getTime();
    const padding = (end - start) * 0.05;
    return [new Date(start - padding), new Date(end + padding)];
  };

  const getRange = (page) => {
    const start = page * PAGE_SIZE;
    const end = Math.min(start + PAGE_SIZE - 1, totalPoints - 1);
    if (!xValues[start] || !xValues[end]) return undefined;
    return addPadding(xValues[start], xValues[end]);
  };

  const currentRange = useMemo(
    () => getRange(pageIndex),
    [pageIndex, xValues]
  );

  const allYValues = sortedData.flatMap(trace => trace.y || []);

  const minY = Math.min(...allYValues);
  const maxY = Math.max(...allYValues);

  const yPadding = (maxY - minY) * 0.15 || 1; 
  const yRange = [
    minY - yPadding,
    maxY + yPadding
  ];

  const enhancedData = sortedData.map(trace => ({
    ...trace,
    line: { ...trace.line, width: 3, shape: "spline" },
    marker: {
      size: 6,
      line: { width: 2, color: "rgba(0,0,0,0.6)" }
    },
    hoverinfo: "x+y+text",
    hoverlabel: {
      bgcolor: "#111",
      font: { size: 13, color: "#fff" }
    }
  }));

  const goNext = () => pageIndex < totalPages - 1 && setPageIndex(p => p + 1);
  const goPrev = () => pageIndex > 0 && setPageIndex(p => p - 1);

  return (
    <div
      style={{
        background: "#fff",
        borderRadius: 16,
        padding: 16,
        boxShadow: "0 8px 24px rgba(0,0,0,0.08)"
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: 12
        }}
      >
        <div style={{ fontSize: 16, fontWeight: 600 }}>
          Level Trend
        </div>

        <div style={{ display: "flex", gap: 8 }}>
          {!showAll && (
            <>
              <button style={btn} onClick={goPrev} disabled={pageIndex === 0}>
                ◀ Prev
              </button>

              <span style={pageInfo}>
                {pageIndex + 1} / {totalPages}
              </span>

              <button
                style={btn}
                onClick={goNext}
                disabled={pageIndex === totalPages - 1}
              >
                Next ▶
              </button>
            </>
          )}

          {showAll && (
            <button
              style={{ ...btn, background: "#f3f4f6" }}
              onClick={() => {
                setShowAll(false);
                setPageIndex(0);
              }}
            >
              ⬅ Back to Paged View
            </button>
          )}
        </div>
      </div>

      <Plot
        data={enhancedData}
        layout={{
          height: 550,
          width: 1400,

          xaxis: {
            title: { text: "<b>Date & Time</b>", ...axisTitleStyle },
            ...axisTickStyle,
            type: "date",
            range: showAll ? undefined : currentRange,
            autorange: showAll
          },

          yaxis: {
            title: { text: "<b>Level</b>", ...axisTitleStyle },
            ...axisTickStyle,
            range: yRange,             
            autorange: false,
            separatethousands: true
          },

          margin: { t: 40, b: 90, l: 80, r: 20 }
        }}
        config={{
          displayModeBar: true,
          displaylogo: false,
          doubleClick: "reset"
        }}
        onDoubleClick={() => setShowAll(true)}
      />
    </div>
  );
};

const btn = {
  padding: "6px 14px",
  borderRadius: 999,
  border: "1px solid #e5e7eb",
  background: "#ffffff",
  cursor: "pointer",
  fontWeight: 500,
  fontSize: 13,
  transition: "all 0.2s ease",
  boxShadow: "0 1px 4px rgba(0,0,0,0.08)"
};

const pageInfo = {
  padding: "6px 12px",
  borderRadius: 999,
  background: "#f9fafb",
  fontSize: 13,
  fontWeight: 500,
  color: "#374151"
};






// export const PressurelineChart = ({ data }) => {
//   const axisTitleStyle = {
//     font: {
//       size: 14,
//       weight: 'bold'
//     },
//     standoff: 20
//   };

//   const axisTickStyle = {
//     tickfont: {
//       weight: 'bold',
//       size: 12
//     }
//   };

//   const enhancedData = data.map(trace => ({
//     ...trace,
//     line: {
//       ...trace.line,
//       width: 3,
//       shape: 'spline',
//     },
    
//     marker: {
//       size: 6,
//       line: {
//         width: 2,
//         color: 'rgba(0,0,0,0.7)'
//       }
//     },
   
//     hoverinfo: 'x+y+text',
//     hoverlabel: {
//       bgcolor: 'rgba(0,0,0,0.8)',
//       font: {
//         size: 14,
//         color: 'white'
//       }
//     }
//   }));

//   return (
//     <Plot
//       data={enhancedData}
//       layout={{
//         height: 450,
//         width: 1100,
//         xaxis: {
//           title: {
//             text: '<b>Date and Time</b>',
//             ...axisTitleStyle
//           },
//           ...axisTickStyle
//         },
//         yaxis: {
//           title: {
//             text: '<b>Pressure</b>',
//             ...axisTitleStyle
//           },
//           ...axisTickStyle,
//           separatethousands: true,
//           hoverformat: ',.3f'
//         },
//         title: {
//           text: '<b>PRESSURE</b>',
//           x: 0.5,
//           xref: 'paper',
//           font: {
//             size: 18,
//             weight: 'bold'
//           }
//         },
//         margin: { t: 50, b: 100, l: 80, r: 10 }, 
//         borderRadius: '15%',
//         overflow: 'hidden',
//         scene: {
//           camera: {
//             eye: { x: 1.5, y: 1.5, z: 1.2 } 
//           }
//         },
//         transition: {
//           duration: 500,
//           easing: 'cubic-in-out'
//         }
//       }}
//       config={{
//         plotGlPixelRatio: 2,
//         transition: {
//           duration: 500,
//           easing: 'cubic-in-out'
//         },
//         displayModeBar: true,
//         displaylogo: false,
//         modeBarButtonsToRemove: ['pan2d', 'lasso2d', 'select2d', 'autoScale2d'],
//         modeBarButtonsToAdd: ['hoverClosestGl2d']
//       }}
//     />
//   );
// };

export const PressurelineChart = ({ data }) => {
  const PAGE_SIZE = 96;

  const axisTitleStyle = {
    font: { size: 14, weight: "bold" },
    standoff: 20
  };

  const axisTickStyle = {
    tickfont: { size: 12, weight: "bold" }
  };

  const [pageIndex, setPageIndex] = useState(0);
  const [showAll, setShowAll] = useState(false);

  const sortTraceByX = (trace) => {
    if (!trace?.x || !trace?.y) return trace;

    const combined = trace.x.map((x, i) => ({
      x,
      y: trace.y[i],
      text: trace.text?.[i]
    }));

    combined.sort((a, b) => new Date(a.x) - new Date(b.x));

    return {
      ...trace,
      x: combined.map(p => p.x),
      y: combined.map(p => p.y),
      text: combined.map(p => p.text)
    };
  };

  const sortedData = useMemo(
    () => data.map(sortTraceByX),
    [data]
  );

  const xValues = sortedData?.[0]?.x || [];
  const totalPoints = xValues.length;
  const totalPages = Math.ceil(totalPoints / PAGE_SIZE);

  const addPadding = (startX, endX) => {
    const start = new Date(startX).getTime();
    const end = new Date(endX).getTime();
    const padding = (end - start) * 0.05;
    return [new Date(start - padding), new Date(end + padding)];
  };

  const getRange = (page) => {
    const start = page * PAGE_SIZE;
    const end = Math.min(start + PAGE_SIZE - 1, totalPoints - 1);
    if (!xValues[start] || !xValues[end]) return undefined;
    return addPadding(xValues[start], xValues[end]);
  };

  const currentRange = useMemo(
    () => getRange(pageIndex),
    [pageIndex, xValues]
  );

  const allYValues = sortedData.flatMap(trace => trace.y || []);

  const minY = Math.min(...allYValues);
  const maxY = Math.max(...allYValues);

  const yPadding = (maxY - minY) * 0.15 || 1; 
  const yRange = [
    minY - yPadding,
    maxY + yPadding
  ];

  const enhancedData = sortedData.map(trace => ({
    ...trace,
    line: { ...trace.line, width: 3, shape: "spline" },
    marker: {
      size: 6,
      line: { width: 2, color: "rgba(0,0,0,0.6)" }
    },
    hoverinfo: "x+y+text",
    hoverlabel: {
      bgcolor: "#111",
      font: { size: 13, color: "#fff" }
    }
  }));

  const goNext = () => pageIndex < totalPages - 1 && setPageIndex(p => p + 1);
  const goPrev = () => pageIndex > 0 && setPageIndex(p => p - 1);

  return (
    <div
      style={{
        background: "#fff",
        borderRadius: 16,
        padding: 16,
        boxShadow: "0 8px 24px rgba(0,0,0,0.08)"
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: 12
        }}
      >
        <div style={{ fontSize: 16, fontWeight: 600 }}>
          Pressure Trend
        </div>

        <div style={{ display: "flex", gap: 8 }}>
          {!showAll && (
            <>
              <button style={btn} onClick={goPrev} disabled={pageIndex === 0}>
                ◀ Prev
              </button>

              <span style={pageInfo}>
                {pageIndex + 1} / {totalPages}
              </span>

              <button
                style={btn}
                onClick={goNext}
                disabled={pageIndex === totalPages - 1}
              >
                Next ▶
              </button>
            </>
          )}

          {showAll && (
            <button
              style={{ ...btn, background: "#f3f4f6" }}
              onClick={() => {
                setShowAll(false);
                setPageIndex(0);
              }}
            >
              ⬅ Back to Paged View
            </button>
          )}
        </div>
      </div>

      <Plot
        data={enhancedData}
        layout={{
          height: 550,
          width: 1400,

          xaxis: {
            title: { text: "<b>Date & Time</b>", ...axisTitleStyle },
            ...axisTickStyle,
            type: "date",
            range: showAll ? undefined : currentRange,
            autorange: showAll
          },

          yaxis: {
            title: { text: "<b>Pressure</b>", ...axisTitleStyle },
            ...axisTickStyle,
            range: yRange,             
            autorange: false,
            separatethousands: true
          },

          margin: { t: 40, b: 90, l: 80, r: 20 }
        }}
        config={{
          displayModeBar: true,
          displaylogo: false,
          doubleClick: "reset"
        }}
        onDoubleClick={() => setShowAll(true)}
      />
    </div>
  );
};

export const LineChartFlowrate = ({ data }) => {
  const PAGE_SIZE = 96;

  const axisTitleStyle = {
    font: { size: 14, weight: "bold" },
    standoff: 20
  };

  const axisTickStyle = {
    tickfont: { size: 12, weight: "bold" }
  };

  const [pageIndex, setPageIndex] = useState(0);
  const [showAll, setShowAll] = useState(false);

  const sortTraceByX = (trace) => {
    if (!trace?.x || !trace?.y) return trace;

    const combined = trace.x.map((x, i) => ({
      x,
      y: trace.y[i],
      text: trace.text?.[i]
    }));

    combined.sort((a, b) => new Date(a.x) - new Date(b.x));

    return {
      ...trace,
      x: combined.map(p => p.x),
      y: combined.map(p => p.y),
      text: combined.map(p => p.text)
    };
  };

  const sortedData = useMemo(
    () => data.map(sortTraceByX),
    [data]
  );

  const xValues = sortedData?.[0]?.x || [];
  const totalPoints = xValues.length;
  const totalPages = Math.ceil(totalPoints / PAGE_SIZE);

  const addPadding = (startX, endX) => {
    const start = new Date(startX).getTime();
    const end = new Date(endX).getTime();
    const padding = (end - start) * 0.05;
    return [new Date(start - padding), new Date(end + padding)];
  };

  const getRange = (page) => {
    const start = page * PAGE_SIZE;
    const end = Math.min(start + PAGE_SIZE - 1, totalPoints - 1);
    if (!xValues[start] || !xValues[end]) return undefined;
    return addPadding(xValues[start], xValues[end]);
  };

  const currentRange = useMemo(
    () => getRange(pageIndex),
    [pageIndex, xValues]
  );

  const allYValues = sortedData.flatMap(trace => trace.y || []);

  const minY = Math.min(...allYValues);
  const maxY = Math.max(...allYValues);

  const yPadding = (maxY - minY) * 0.15 || 1; 
  const yRange = [
    minY - yPadding,
    maxY + yPadding
  ];

  const enhancedData = sortedData.map(trace => ({
    ...trace,
    line: { ...trace.line, width: 3, shape: "spline" },
    marker: {
      size: 6,
      line: { width: 2, color: "rgba(0,0,0,0.6)" }
    },
    hoverinfo: "x+y+text",
    hoverlabel: {
      bgcolor: "#111",
      font: { size: 13, color: "#fff" }
    }
  }));

  const goNext = () => pageIndex < totalPages - 1 && setPageIndex(p => p + 1);
  const goPrev = () => pageIndex > 0 && setPageIndex(p => p - 1);

  return (
    <div
      style={{
        background: "#fff",
        borderRadius: 16,
        padding: 16,
        boxShadow: "0 8px 24px rgba(0,0,0,0.08)"
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: 12
        }}
      >
        <div style={{ fontSize: 16, fontWeight: 600 }}>
          Flowrate Trend
        </div>

        <div style={{ display: "flex", gap: 8 }}>
          {!showAll && (
            <>
              <button style={btn} onClick={goPrev} disabled={pageIndex === 0}>
                ◀ Prev
              </button>

              <span style={pageInfo}>
                {pageIndex + 1} / {totalPages}
              </span>

              <button
                style={btn}
                onClick={goNext}
                disabled={pageIndex === totalPages - 1}
              >
                Next ▶
              </button>
            </>
          )}

          {showAll && (
            <button
              style={{ ...btn, background: "#f3f4f6" }}
              onClick={() => {
                setShowAll(false);
                setPageIndex(0);
              }}
            >
              ⬅ Back to Paged View
            </button>
          )}
        </div>
      </div>

      <Plot
        data={enhancedData}
        layout={{
          height: 550,
          width: 1400,

          xaxis: {
            title: { text: "<b>Date & Time</b>", ...axisTitleStyle },
            ...axisTickStyle,
            type: "date",
            range: showAll ? undefined : currentRange,
            autorange: showAll
          },

          yaxis: {
            title: { text: "<b>Flowrate</b>", ...axisTitleStyle },
            ...axisTickStyle,
            range: yRange,             
            autorange: false,
            separatethousands: true
          },

          margin: { t: 40, b: 90, l: 80, r: 20 }
        }}
        config={{
          displayModeBar: true,
          displaylogo: false,
          doubleClick: "reset"
        }}
        onDoubleClick={() => setShowAll(true)}
      />
    </div>
  );
};


  